module.exports = __webpack_public_path__ + "static/tent-e5b649a4b2b3b1f40edc2505e8cc6694.png";